import React from 'react';
import { motion } from 'framer-motion';
const colors = [{
  name: 'PURE WHITE',
  hex: '#FFFFFF',
  rgb: '255, 255, 255',
  cmyk: '0, 0, 0, 0',
  bg: 'bg-white',
  text: 'text-navy',
  border: 'border-r-2 border-navy'
}, {
  name: 'ELECTRIC CORAL',
  hex: '#FF6B4A',
  rgb: '255, 107, 74',
  cmyk: '0, 75, 75, 0',
  bg: 'bg-coral',
  text: 'text-white',
  border: 'border-r-2 border-navy'
}, {
  name: 'DEEP NAVY',
  hex: '#0A1628',
  rgb: '10, 22, 40',
  cmyk: '85, 70, 50, 60',
  bg: 'bg-navy',
  text: 'text-white',
  border: ''
}];
export function ColorPalette() {
  return <section className="w-full border-b-2 border-navy" data-id="element-29">
      <div className="grid grid-cols-1 md:grid-cols-3 min-h-[600px]" data-id="element-30">
        {colors.map((color, i) => <motion.div key={color.name} initial={{
        x: -50,
        opacity: 0
      }} whileInView={{
        x: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.2,
        duration: 0.6
      }} className={`${color.bg} ${color.border} p-8 md:p-12 flex flex-col justify-between relative group`} data-id="element-31">
            <div className={`font-mono text-sm tracking-widest ${color.text} opacity-60`} data-id="element-32">
              02.{i + 1}
            </div>

            <div className="space-y-6" data-id="element-33">
              <h3 className={`text-4xl md:text-5xl font-bold ${color.text} tracking-tight`} data-id="element-34">
                {color.name}
              </h3>

              <div className={`font-mono text-sm md:text-base space-y-2 ${color.text} opacity-80 border-t ${color.text === 'text-white' ? 'border-white/30' : 'border-navy/30'} pt-6`} data-id="element-35">
                <div className="flex justify-between" data-id="element-36">
                  <span data-id="element-37">HEX</span>
                  <span data-id="element-38">{color.hex}</span>
                </div>
                <div className="flex justify-between" data-id="element-39">
                  <span data-id="element-40">RGB</span>
                  <span data-id="element-41">{color.rgb}</span>
                </div>
                <div className="flex justify-between" data-id="element-42">
                  <span data-id="element-43">CMYK</span>
                  <span data-id="element-44">{color.cmyk}</span>
                </div>
              </div>
            </div>

            {/* Hover Effect */}
            <div className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-45" />
          </motion.div>)}
      </div>
    </section>;
}